import { Injectable } from '@angular/core';
import { ActivatedRoute, RouterState } from '@angular/router';
import { Subject } from 'rxjs';
import { QueryParams } from 'src/app/models/queryParams';
import { PageType } from 'src/app/models/enums';

@Injectable()
export class QueryParamsService {

  /* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
  private _pageType: PageType;
  private _queryParameters: QueryParams;
  private queryParamsSource = new Subject<QueryParams>();
  public queryParamsChanged$ = this.queryParamsSource.asObservable();
  private pageTypeSource = new Subject<PageType>();
  public pageTypeChanged$ = this.pageTypeSource.asObservable();

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      // const a = JSON.stringify(params);
      // console.log('queryParamsService params:' + JSON.stringify(params));
      this._queryParameters = new QueryParams(params);
      this.queryParamsSource.next(this._queryParameters);
    });
  }

  get queryParameters() {
    return this._queryParameters;
  }

  set pageType(pageType: PageType) {
    if (this._pageType !== pageType) {
      this._pageType = pageType;
      this.pageTypeSource.next(this._pageType);
    }
  }

  get pageType() {
    return this._pageType;
  }
}
